export default "__VITE_PUBLIC_ASSET__27c56884__"